import { useEffect, useState } from 'react';
import { PlaceIcon } from '@trufla-technology/trumarket-react-design-system';
import './style.scss';
import { ListLocations } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types/index';
import {
  Button,
  useToastContext,
} from '@trufla-technology/trumarket-react-design-system';
import { groupBy } from 'lodash';
import { useHistory } from 'react-router-dom';
import { useUpdateCompanyLocation } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { IErrorResponse } from 'app/types/ErrorResponse';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';

interface IProps {
  data: ListLocations[number];
  getBranches: () => void;
}
interface IWorkingDays {
  day: string;
  time: string;
}
interface IGroupByIWorkingDays {
  [key: string]: IWorkingDays[];
}

export const BranchCard = ({ data, getBranches }: IProps) => {
  const { isPermitted } = useAuthContext();
  const [state, setState] = useState<IGroupByIWorkingDays>();
  const history = useHistory();
  const toaster = useToastContext();

  const UpdateCompanyLocation = useUpdateCompanyLocation();
  useEffect(() => {
    if (data.workingHours) {
      const groupByWorkingDays = groupBy(
        [
          ...data.workingHours.map((x) => {
            return { day: x.day, time: `from ${x.from} to ${x.to}` };
          }),
        ],
        'time',
      );
      setState(groupByWorkingDays);
    }
  }, [data]);
  const handleSetDefault = async (key: string) => {
    try {
      await UpdateCompanyLocation(key, { headquarter: true });
      await getBranches();
      toaster.success('Successfully changed branch to default');
    } catch (error) {
      const errorMessage = (
        error as IErrorResponse
      )?.response?.data?.error.replaceAll('body.', '');
      toaster.error(errorMessage || 'Failed to set default branch');
    }
  };
  return (
    <div className="cover-branch-card">
      {data && (
        <div className={`branch-card ${data.headquarter ? 'active' : ''}`}>
          <div className="icon-section">
            {isPermitted('updateCompanyLocation') && (
              <div className="actions-section">
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() =>
                    history.push(
                      `/configurations/company-details/edit/${data.key}`,
                    )
                  }
                >
                  Open
                </Button>
                <Button
                  disabled={data.headquarter}
                  classes="btn-set-default"
                  onClick={() => data.key && handleSetDefault(data.key)}
                >
                  Set Default
                </Button>
                {/* <Button classes="btn-delete">Delete</Button> */}
              </div>
            )}
            <div className="icon">
              <PlaceIcon width="12px" />
            </div>
            {data.headquarter && <p>Default</p>}
          </div>
          <div className="info">
            <p className="title">{data.name}</p>
            {data.address && (
              <p>{` ${data.address.street},  ${
                data.address.floor ? 'floor ' + data.address.floor : ''
              }, ${data.address.suite ? 'suite ' + data.address.suite : ''}, ${
                data.address.city
              }, ${data.address.country}`}</p>
            )}
            <p>
              {/* @ts-ignore */}
              {data?.phones?.map(
                (
                  phone: {
                    type?: string | undefined;
                    number?: string | undefined;
                  },
                  index: number,
                ) => {
                  return (
                    <>
                      {index !== 0 && ','}
                      {phone.type!!}: {phone.number!!}
                    </>
                  );
                },
              )}
            </p>
            <p className="branch-timings">
              {state &&
                Object.keys(state).map((keyName, i) => (
                  <span key={i}>
                    {state[keyName].map((x: IWorkingDays, index: number) => {
                      return (
                        <span key={index}>
                          {index !== 0 && ', '}
                          {x.day.toLowerCase()}
                        </span>
                      );
                    })}{' '}
                    : {keyName}
                  </span>
                ))}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
